<template>
  <div v-cloak v-if="value && value.length" class="job-in-focus-box">
    <div class="row job-in-focus-box-headline">
      <div class="col-6">
        <h6 class="d-none d-md-block">{{ bundle.id_10883 }}</h6>
        <h6 class="d-block d-md-none unprintable">
          <a :href="computedMoreLink">{{ bundle.id_10883 }}<i class="fa-light fa-chevron-right ms-2"></i></a>
        </h6>
      </div>
      <div v-if="numberOfSlides > 1" class="col-6 text-end d-none d-md-block unprintable">
        <a href="#" @click.prevent="previousSlide" class="arrow">
          <i class="fa-light fa-angle-left"/>
        </a>
        <a href="#" @click.prevent="nextSlide" class="arrow">
          <i class="fa-light fa-angle-right"/>
        </a>
      </div>
      <div v-if="numberOfSlides > 1" class="col-6 text-end d-md-none unprintable">
        <a href="#"
           v-for="i in numberOfSlides"
           :key="'slide-top-' + i"
           @click.prevent="jumpToSlide(i)"
           class="dot"
           :class="{'active': i == currentSlide}">
          <i class="fa-solid fa-circle"/>
        </a>
      </div>
    </div>
    <div @touchstart="onTouchStart"
         @touchmove="onTouchMove"
         @mouseover="onMouseOver"
         @mouseout="onMouseOut">
      <transition :name="slideDirection" mode="out-in">
        <div :key="currentSlide" class="row jobs-transition">
          <div v-for="job in currentJobs" :key="'job-' + job.id" class="col-12 col-md-6">
            <tracker a="impression" tn="job" :tr="job.id">
              <a :href="job.href" class="job">
                <div class="logo">
                  <img :src="job.logo" loading="lazy"/>
                </div>
                <div class="text">
                  <div class="company">{{ job.company }}</div>
                  <div class="title" :title="job.title">{{ job.title }}</div>
                  <div class="location"><i class="fa-light fa-location-dot"/>{{ job.location }}</div>
                </div>
              </a>
            </tracker>
          </div>
          <div v-for="i in 4 - currentJobs.length" :key="'job-placeholder-' + i" class="col-12 col-md-6 d-flex">
          </div>
        </div>
      </transition>
    </div>
    <div v-if="numberOfSlides > 1" class="text-end d-none d-md-block unprintable">
      <a href="#"
         v-for="i in numberOfSlides"
         :key="'slide-bottom-' + i"
         @click.prevent="jumpToSlide(i)"
         class="dot"
         :class="{'active': i == currentSlide}">
        <i class="fa-solid fa-circle"/>
      </a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "job-in-focus-box",
  props: {
    value: {
      type: Array,
      required: true
    },
    autoRotate: {
      type: Boolean,
      default: true
    },
    moreLink: {
      type: String,
      default: "/job"
    }
  },
  data: function () {
    return {
      contextPath: window.contextPath,
      hovering: false,
      interval: null,
      rotationSpeed: 5000,
      slideDirection: "",
      currentSlide: 1,
      currentSize: 4,
      touchStartX: 0,
      touchCurrentX: 0,
      touchSlide: null,
      bundle: {
        id_10883: "Featured Jobs"
      }
    };
  },
  created: function () {
    Vue.$bundle("portal", this.bundle, (bundle) => {
      this.bundle = bundle;
    });
  },
  mounted: function () {
    this.startRotation();
  },
  beforeDestroy: function () {
    this.stopRotation();
  },
  computed: {
    computedMoreLink: function () {
      if (this.moreLink.startsWith("/")) {
        return this.contextPath + this.moreLink;
      }
      return this.moreLink;
    },
    numberOfSlides: function () {
      if (!this.value) {
        return 0;
      }
      return Math.ceil(this.value.length / this.currentSize);
    },
    currentJobs: function () {
      if (!this.value) {
        return [];
      }
      return this.value.slice(
          (this.currentSlide - 1) * this.currentSize,
          ((this.currentSlide - 1) * this.currentSize) + this.currentSize
      );
    }
  },
  watch: {
    hovering: function (newValue) {
      if (newValue) {
        this.stopRotation();
      } else {
        this.startRotation();
      }
    }
  },
  methods: {
    startRotation: function () {
      if (this.autoRotate && !this.interval) {
        this.interval = setInterval(() => {
          this.nextSlide();
        }, this.rotationSpeed);
      }
    },
    stopRotation: function () {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    jumpToSlide: function (newSlide) {
      if (this.currentSlide < newSlide) {
        this.slideDirection = 'slide-left';
      } else if (this.currentSlide > newSlide) {
        this.slideDirection = 'slide-right';
      }
      this.currentSlide = newSlide;
    },
    previousSlide: function () {
      this.slideDirection = 'slide-right';
      if (this.currentSlide > 1) {
        this.currentSlide--;
      } else {
        this.currentSlide = this.numberOfSlides;
      }
    },
    nextSlide: function () {
      this.slideDirection = 'slide-left';
      if (this.currentSlide < this.numberOfSlides) {
        this.currentSlide++;
      } else {
        this.currentSlide = 1;
      }
    },
    onTouchStart: function (event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchSlide = this.currentSlide;
    },
    onTouchMove: function (event) {
      if (this.currentSlide != this.touchSlide) {
        event.preventDefault();
        return;
      }

      this.touchCurrentX = event.touches[0].clientX;
      const deltaX = this.touchCurrentX - this.touchStartX;

      if (deltaX > 50) {
        event.preventDefault();
        this.previousSlide();
      } else if (deltaX < -50) {
        event.preventDefault();
        this.nextSlide();
      }
    },
    onMouseOver: function () {
      this.hovering = true;
    },
    onMouseOut: function () {
      this.hovering = false;
    }
  }
}
</script>

<style lang="less">
.job-in-focus-box {
  margin: 1.5rem -1.25rem 2.25rem -1.25rem;
  overflow: hidden;
  padding: 0 1.25rem;

  @media (min-width: 768px) {
    margin: 0 0 3rem 0;
    overflow: visible;
    padding: 0;
  }

  a {
    color: var(--nm-black);

    &:active, &:hover {
      color: var(--nm-black);
    }
  }

  h6 {
    font-size: 1.25rem;
    font-weight: 700;
    margin: 0;
  }

  .job-in-focus-box-headline {
    margin-bottom: 1.25rem;
  }

  .arrow {
    color: var(--nm-grey-60);
    font-size: 1.75rem;
    line-height: 1.75rem;
    margin-left: 1.5rem;
    vertical-align: middle;
  }

  .dot {
    color: var(--nm-grey-10);
    font-size: .4375rem;
    vertical-align: middle;

    &.active {
      color: var(--nm-grey-80);
    }

    & + .dot {
      margin-left: .75rem;
    }
  }

  .jobs-transition {
    min-height: 35.75rem;

    @media (min-width: 768px) {
      min-height: 19.125rem;
    }
  }

  .job {
    border-bottom: 1px solid var(--nm-grey-10);
    display: flex;
    padding-bottom: 1.5rem;
    margin-bottom: 1.5rem;
    width: 100%;

    div {
      align-self: center;
      display: inline-block;

      &.logo {
        flex: 0 0 auto;
        margin-right: 1.5rem;
        text-align: center;
        width: 75px;

        @media (min-width: 768px) {
          width: 100px;
        }

        img {
          max-width: 100%;
        }
      }

      &.text {
        flex: 1 0 0%;

        div {
          display: block;

          // Cut text short to keep it on one line.
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;

          &.company {
            color: var(--nm-grey-60);
            font-size: .75rem;
            font-weight: 500;
            margin-bottom: .25rem;

            @media (min-width: 768px) {
              font-size: .875rem;
            }
          }

          &.title {
            color: var(--nm-black);
            font-size: 1rem;
            font-weight: 700;
            margin-bottom: .375rem;

            // Cut text short to keep it on two lines.
            height: 3rem;
            -webkit-line-clamp: 2;

            @media (min-width: 768px) {
              margin-bottom: .625rem;
            }
          }

          &.location {
            color: var(--nm-grey-60);
            font-size: .75rem;
            font-weight: 600;

            @media (min-width: 768px) {
              font-size: .875rem;
            }

            i {
              margin-right: .375rem;
            }
          }
        }
      }
    }
  }
}
</style>